import { useDispatch, useSelector } from "react-redux";
import { crossIcon } from "../../../Assets/svg";
import { setConfig } from "../../../Store/Slices/PlayerSlice";
import { SetPlaylistTrackId } from "../../../Util/helpers";

const MixerItem = ({ data, onRemove }) => {

    const dispatch = useDispatch();
    const config = useSelector((state) => state.player.config);
    const shouldPlay = config?.shouldPlay;
    const showHighlightedColor = config['type'] === 'playlist' && (data?.id === config.playingId || data?.id === shouldPlay || data?.type === 'sounds' && data.soundcategory !== 164 && data.soundcategory !== 163)
    const showCrossIcon = true; // config?.type !== 'playlist' && config?.type !== 'mix'
    const isAudio = ["relaxation", "articles", "stories"];

    const handlePlayTrack = () => {
        if (config?.type === 'playlist' && (data.soundcategory === 164 || data.soundcategory === 163 || isAudio.includes(data?.type)) && data?.id !== config?.playingId) {
            dispatch(setConfig({ playingId: data?.id, restartId: data?.id }));
            SetPlaylistTrackId(data?.id);
        }
    }

    return (
        <div className="mixerSoundDetail px-3 py-2">
            <div className="mixerSoundThumbnailWrapper flex-shrink-0">
                <div className="mixerAudioThumbnail">
                    <img src={data?.image} alt="Thumbnail" />
                </div>
            </div>
            <div className="flex-grow-1" onClick={handlePlayTrack}>
                <p className={`mixerAudioTitle cursor-pointer fw-normal ${showHighlightedColor && 'goldenColor2'}`}>{data?.title ?? data?.name}</p>
            </div>
            <div className="d-flex align-center gap-2 flex-shrink-0">
                {showCrossIcon && <span className="soundControlButton" onClick={() => onRemove?.(data)}>
                    <img src={crossIcon} alt="Cross Icon" />
                </span>}
            </div>
        </div>
    )
};

export default MixerItem;